import { atomWithStorage } from 'jotai/utils';

import { Geo, LocalStorageKey } from 'v2/constants';

export const geoAtom = atomWithStorage<Geo>(LocalStorageKey.GEO, Geo.RU, undefined, { getOnInit: true });
